@file:OptIn(InternalResourceApi::class)

package crossly.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/crossly.shared.generated.resources/"

@delegate:ResourceContentHash(-1_713_908_831)
internal val Res.string.challenge_own_result: StringResource by lazy {
      StringResource("string:challenge_own_result", "challenge_own_result", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5413, 72),
      ))
    }

@delegate:ResourceContentHash(-1_560_426_799)
internal val Res.string.challenge_play_more: StringResource by lazy {
      StringResource("string:challenge_play_more", "challenge_play_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5486, 59),
      ))
    }

@delegate:ResourceContentHash(383_711_881)
internal val Res.string.challenge_result_time: StringResource by lazy {
      StringResource("string:challenge_result_time", "challenge_result_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5546, 57),
      ))
    }

@delegate:ResourceContentHash(1_279_552_107)
internal val Res.string.challenge_result_won: StringResource by lazy {
      StringResource("string:challenge_result_won", "challenge_result_won", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5604, 52),
      ))
    }

@delegate:ResourceContentHash(-1_977_898_449)
internal val Res.string.challenge_share: StringResource by lazy {
      StringResource("string:challenge_share", "challenge_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5657, 31),
      ))
    }

@delegate:ResourceContentHash(-34_787_078)
internal val Res.string.challenge_start_fresh: StringResource by lazy {
      StringResource("string:challenge_start_fresh", "challenge_start_fresh", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5689, 61),
      ))
    }

@delegate:ResourceContentHash(1_466_483_662)
internal val Res.string.coach_levels_kicker: StringResource by lazy {
      StringResource("string:coach_levels_kicker", "coach_levels_kicker", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5751, 35),
      ))
    }

@delegate:ResourceContentHash(-1_602_102_512)
internal val Res.string.coach_levels_next_body: StringResource by lazy {
      StringResource("string:coach_levels_next_body", "coach_levels_next_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5787, 146),
      ))
    }

@delegate:ResourceContentHash(-208_643_197)
internal val Res.string.coach_levels_next_title: StringResource by lazy {
      StringResource("string:coach_levels_next_title", "coach_levels_next_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5934, 47),
      ))
    }

@delegate:ResourceContentHash(1_607_158_331)
internal val Res.string.coach_levels_resume_body: StringResource by lazy {
      StringResource("string:coach_levels_resume_body", "coach_levels_resume_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5982, 132),
      ))
    }

@delegate:ResourceContentHash(-1_043_720_218)
internal val Res.string.coach_levels_resume_title: StringResource by lazy {
      StringResource("string:coach_levels_resume_title", "coach_levels_resume_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6115, 69),
      ))
    }

@delegate:ResourceContentHash(1_756_623_005)
internal val Res.string.coach_levels_tiers_body: StringResource by lazy {
      StringResource("string:coach_levels_tiers_body", "coach_levels_tiers_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6185, 123),
      ))
    }

@delegate:ResourceContentHash(-1_353_692_800)
internal val Res.string.coach_levels_tiers_title: StringResource by lazy {
      StringResource("string:coach_levels_tiers_title", "coach_levels_tiers_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6309, 56),
      ))
    }

@delegate:ResourceContentHash(986_974_438)
internal val Res.string.coach_play_cell_body: StringResource by lazy {
      StringResource("string:coach_play_cell_body", "coach_play_cell_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6366, 120),
      ))
    }

@delegate:ResourceContentHash(-2_129_414_434)
internal val Res.string.coach_play_cell_title: StringResource by lazy {
      StringResource("string:coach_play_cell_title", "coach_play_cell_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6487, 45),
      ))
    }

@delegate:ResourceContentHash(-14_492_519)
internal val Res.string.coach_play_got_it: StringResource by lazy {
      StringResource("string:coach_play_got_it", "coach_play_got_it", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6533, 33),
      ))
    }

@delegate:ResourceContentHash(1_475_488_990)
internal val Res.string.coach_play_hint_body: StringResource by lazy {
      StringResource("string:coach_play_hint_body", "coach_play_hint_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6567, 144),
      ))
    }

@delegate:ResourceContentHash(-123_866_334)
internal val Res.string.coach_play_hint_title: StringResource by lazy {
      StringResource("string:coach_play_hint_title", "coach_play_hint_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6712, 49),
      ))
    }

@delegate:ResourceContentHash(2_093_094_546)
internal val Res.string.coach_play_kicker: StringResource by lazy {
      StringResource("string:coach_play_kicker", "coach_play_kicker", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6762, 41),
      ))
    }

@delegate:ResourceContentHash(2_021_624_528)
internal val Res.string.coach_play_letters_body: StringResource by lazy {
      StringResource("string:coach_play_letters_body", "coach_play_letters_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6804, 159),
      ))
    }

@delegate:ResourceContentHash(444_280_557)
internal val Res.string.coach_play_letters_title: StringResource by lazy {
      StringResource("string:coach_play_letters_title", "coach_play_letters_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6964, 52),
      ))
    }

@delegate:ResourceContentHash(834_007_092)
internal val Res.string.coach_play_next: StringResource by lazy {
      StringResource("string:coach_play_next", "coach_play_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7017, 31),
      ))
    }

@delegate:ResourceContentHash(-1_627_003_497)
internal val Res.string.coach_play_skip: StringResource by lazy {
      StringResource("string:coach_play_skip", "coach_play_skip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7049, 31),
      ))
    }

@delegate:ResourceContentHash(-317_266_980)
internal val Res.string.coach_play_step: StringResource by lazy {
      StringResource("string:coach_play_step", "coach_play_step", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7081, 39),
      ))
    }

@delegate:ResourceContentHash(-1_135_975_042)
internal val Res.string.coach_resume_home_body: StringResource by lazy {
      StringResource("string:coach_resume_home_body", "coach_resume_home_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7121, 130),
      ))
    }

@delegate:ResourceContentHash(675_018_658)
internal val Res.string.coach_resume_home_title: StringResource by lazy {
      StringResource("string:coach_resume_home_title", "coach_resume_home_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7252, 51),
      ))
    }

@delegate:ResourceContentHash(-798_813_201)
internal val Res.string.coach_resume_kicker: StringResource by lazy {
      StringResource("string:coach_resume_kicker", "coach_resume_kicker", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7304, 43),
      ))
    }

@delegate:ResourceContentHash(951_347_839)
internal val Res.string.coach_resume_play_body: StringResource by lazy {
      StringResource("string:coach_resume_play_body", "coach_resume_play_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7348, 146),
      ))
    }

@delegate:ResourceContentHash(62_847_932)
internal val Res.string.coach_resume_play_title: StringResource by lazy {
      StringResource("string:coach_resume_play_title", "coach_resume_play_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7495, 63),
      ))
    }

@delegate:ResourceContentHash(-507_690_378)
internal val Res.string.common_back: StringResource by lazy {
      StringResource("string:common_back", "common_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7559, 27),
      ))
    }

@delegate:ResourceContentHash(-1_320_945_082)
internal val Res.string.common_cancel: StringResource by lazy {
      StringResource("string:common_cancel", "common_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7587, 29),
      ))
    }

@delegate:ResourceContentHash(1_507_453_160)
internal val Res.string.common_done: StringResource by lazy {
      StringResource("string:common_done", "common_done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7617, 27),
      ))
    }

@delegate:ResourceContentHash(364_452_867)
internal val Res.string.common_error_generic: StringResource by lazy {
      StringResource("string:common_error_generic", "common_error_generic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7645, 56),
      ))
    }

@delegate:ResourceContentHash(-586_050_058)
internal val Res.string.common_loading: StringResource by lazy {
      StringResource("string:common_loading", "common_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7702, 38),
      ))
    }

@delegate:ResourceContentHash(2_552_198)
internal val Res.string.common_ok: StringResource by lazy {
      StringResource("string:common_ok", "common_ok", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7741, 21),
      ))
    }

@delegate:ResourceContentHash(-1_721_829_073)
internal val Res.string.common_retry: StringResource by lazy {
      StringResource("string:common_retry", "common_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7763, 28),
      ))
    }

@delegate:ResourceContentHash(-355_864_792)
internal val Res.string.crossword_check: StringResource by lazy {
      StringResource("string:crossword_check", "crossword_check", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7792, 31),
      ))
    }

@delegate:ResourceContentHash(47_779_016)
internal val Res.string.crossword_clues: StringResource by lazy {
      StringResource("string:crossword_clues", "crossword_clues", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7824, 31),
      ))
    }

@delegate:ResourceContentHash(703_363_112)
internal val Res.string.crossword_countdown_go: StringResource by lazy {
      StringResource("string:crossword_countdown_go", "crossword_countdown_go", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7856, 42),
      ))
    }

@delegate:ResourceContentHash(1_875_245_623)
internal val Res.string.crossword_daily_badge: StringResource by lazy {
      StringResource("string:crossword_daily_badge", "crossword_daily_badge", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7899, 37),
      ))
    }

@delegate:ResourceContentHash(-1_959_108_374)
internal val Res.string.crossword_delete: StringResource by lazy {
      StringResource("string:crossword_delete", "crossword_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7937, 32),
      ))
    }

@delegate:ResourceContentHash(1_684_916_174)
internal val Res.string.crossword_direction_across: StringResource by lazy {
      StringResource("string:crossword_direction_across", "crossword_direction_across", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7970, 42),
      ))
    }

@delegate:ResourceContentHash(1_446_760_244)
internal val Res.string.crossword_direction_down: StringResource by lazy {
      StringResource("string:crossword_direction_down", "crossword_direction_down", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8013, 40),
      ))
    }

@delegate:ResourceContentHash(-1_963_643_428)
internal val Res.string.crossword_filled: StringResource by lazy {
      StringResource("string:crossword_filled", "crossword_filled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8054, 32),
      ))
    }

@delegate:ResourceContentHash(-1_185_660_163)
internal val Res.string.crossword_hints_left: StringResource by lazy {
      StringResource("string:crossword_hints_left", "crossword_hints_left", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8087, 40),
      ))
    }

@delegate:ResourceContentHash(-1_026_706_258)
internal val Res.string.crossword_hints_none: StringResource by lazy {
      StringResource("string:crossword_hints_none", "crossword_hints_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8128, 48),
      ))
    }

@delegate:ResourceContentHash(-1_789_949_778)
internal val Res.string.crossword_mistakes: StringResource by lazy {
      StringResource("string:crossword_mistakes", "crossword_mistakes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8177, 38),
      ))
    }

@delegate:ResourceContentHash(-48_812_294)
internal val Res.string.crossword_next_clue: StringResource by lazy {
      StringResource("string:crossword_next_clue", "crossword_next_clue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8216, 39),
      ))
    }

@delegate:ResourceContentHash(700_241_319)
internal val Res.string.crossword_no_clue: StringResource by lazy {
      StringResource("string:crossword_no_clue", "crossword_no_clue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8256, 53),
      ))
    }

@delegate:ResourceContentHash(-2_120_916_872)
internal val Res.string.crossword_no_stars: StringResource by lazy {
      StringResource("string:crossword_no_stars", "crossword_no_stars", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8310, 82),
      ))
    }

@delegate:ResourceContentHash(-950_158_529)
internal val Res.string.crossword_prev_clue: StringResource by lazy {
      StringResource("string:crossword_prev_clue", "crossword_prev_clue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8393, 47),
      ))
    }

@delegate:ResourceContentHash(1_535_307_061)
internal val Res.string.crossword_progress: StringResource by lazy {
      StringResource("string:crossword_progress", "crossword_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8441, 42),
      ))
    }

@delegate:ResourceContentHash(2_499_250)
internal val Res.string.crossword_reveal_ad_caption: StringResource by lazy {
      StringResource("string:crossword_reveal_ad_caption", "crossword_reveal_ad_caption", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8484, 39),
      ))
    }

@delegate:ResourceContentHash(-1_062_120_929)
internal val Res.string.crossword_reveal_ad_loading: StringResource by lazy {
      StringResource("string:crossword_reveal_ad_loading", "crossword_reveal_ad_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8524, 55),
      ))
    }

@delegate:ResourceContentHash(1_814_922_256)
internal val Res.string.crossword_reveal_cell: StringResource by lazy {
      StringResource("string:crossword_reveal_cell", "crossword_reveal_cell", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8750, 49),
      ))
    }

@delegate:ResourceContentHash(1_265_360_363)
internal val Res.string.crossword_reveal_cell_count: StringResource by lazy {
      StringResource("string:crossword_reveal_cell_count", "crossword_reveal_cell_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8642, 63),
      ))
    }

@delegate:ResourceContentHash(-792_822_057)
internal val Res.string.crossword_reveal_cell_count_short: StringResource by lazy {
      StringResource("string:crossword_reveal_cell_count_short", "crossword_reveal_cell_count_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8580, 61),
      ))
    }

@delegate:ResourceContentHash(1_464_918_099)
internal val Res.string.crossword_reveal_cell_short: StringResource by lazy {
      StringResource("string:crossword_reveal_cell_short", "crossword_reveal_cell_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8706, 43),
      ))
    }

@delegate:ResourceContentHash(-1_016_309_043)
internal val Res.string.crossword_reveal_grid: StringResource by lazy {
      StringResource("string:crossword_reveal_grid", "crossword_reveal_grid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8844, 49),
      ))
    }

@delegate:ResourceContentHash(-194_126_705)
internal val Res.string.crossword_reveal_grid_short: StringResource by lazy {
      StringResource("string:crossword_reveal_grid_short", "crossword_reveal_grid_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8800, 43),
      ))
    }

@delegate:ResourceContentHash(2_123_424_958)
internal val Res.string.home_choose_mode: StringResource by lazy {
      StringResource("string:home_choose_mode", "home_choose_mode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8894, 52),
      ))
    }

@delegate:ResourceContentHash(-779_622_928)
internal val Res.string.home_daily: StringResource by lazy {
      StringResource("string:home_daily", "home_daily", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9089, 34),
      ))
    }

@delegate:ResourceContentHash(1_679_753_748)
internal val Res.string.home_daily_done: StringResource by lazy {
      StringResource("string:home_daily_done", "home_daily_done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8947, 39),
      ))
    }

@delegate:ResourceContentHash(935_661_970)
internal val Res.string.home_daily_streak: StringResource by lazy {
      StringResource("string:home_daily_streak", "home_daily_streak", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8987, 41),
      ))
    }

@delegate:ResourceContentHash(1_442_980_341)
internal val Res.string.home_daily_subtitle: StringResource by lazy {
      StringResource("string:home_daily_subtitle", "home_daily_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9029, 59),
      ))
    }

@delegate:ResourceContentHash(-62_091_986)
internal val Res.string.home_play: StringResource by lazy {
      StringResource("string:home_play", "home_play", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9187, 25),
      ))
    }

@delegate:ResourceContentHash(735_244_247)
internal val Res.string.home_play_subtitle: StringResource by lazy {
      StringResource("string:home_play_subtitle", "home_play_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9124, 62),
      ))
    }

@delegate:ResourceContentHash(209_248_934)
internal val Res.string.home_progress_label: StringResource by lazy {
      StringResource("string:home_progress_label", "home_progress_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9213, 43),
      ))
    }

@delegate:ResourceContentHash(-26_045_920)
internal val Res.string.home_resume: StringResource by lazy {
      StringResource("string:home_resume", "home_resume", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9320, 39),
      ))
    }

@delegate:ResourceContentHash(-924_607_721)
internal val Res.string.home_resume_detail: StringResource by lazy {
      StringResource("string:home_resume_detail", "home_resume_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9257, 62),
      ))
    }

@delegate:ResourceContentHash(981_687_349)
internal val Res.string.home_stat_solved: StringResource by lazy {
      StringResource("string:home_stat_solved", "home_stat_solved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9360, 32),
      ))
    }

@delegate:ResourceContentHash(-1_720_235_377)
internal val Res.string.home_stat_stars: StringResource by lazy {
      StringResource("string:home_stat_stars", "home_stat_stars", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9393, 31),
      ))
    }

@delegate:ResourceContentHash(-1_033_225_275)
internal val Res.string.home_stat_streak: StringResource by lazy {
      StringResource("string:home_stat_streak", "home_stat_streak", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9425, 40),
      ))
    }

@delegate:ResourceContentHash(-1_341_485_715)
internal val Res.string.home_subtitle: StringResource by lazy {
      StringResource("string:home_subtitle", "home_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9466, 45),
      ))
    }

@delegate:ResourceContentHash(-1_221_281_274)
internal val Res.string.home_tagline: StringResource by lazy {
      StringResource("string:home_tagline", "home_tagline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9512, 76),
      ))
    }

@delegate:ResourceContentHash(1_327_146_415)
internal val Res.string.home_title: StringResource by lazy {
      StringResource("string:home_title", "home_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9589, 30),
      ))
    }

@delegate:ResourceContentHash(1_686_539_990)
internal val Res.string.levelselect_empty: StringResource by lazy {
      StringResource("string:levelselect_empty", "levelselect_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9620, 65),
      ))
    }

@delegate:ResourceContentHash(-937_956_301)
internal val Res.string.levelselect_level_number: StringResource by lazy {
      StringResource("string:levelselect_level_number", "levelselect_level_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9686, 48),
      ))
    }

@delegate:ResourceContentHash(688_127_370)
internal val Res.string.levelselect_locked: StringResource by lazy {
      StringResource("string:levelselect_locked", "levelselect_locked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9847, 34),
      ))
    }

@delegate:ResourceContentHash(-1_923_868_852)
internal val Res.string.levelselect_locked_tier: StringResource by lazy {
      StringResource("string:levelselect_locked_tier", "levelselect_locked_tier", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9735, 111),
      ))
    }

@delegate:ResourceContentHash(-1_653_482_582)
internal val Res.string.levelselect_resume: StringResource by lazy {
      StringResource("string:levelselect_resume", "levelselect_resume", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9882, 34),
      ))
    }

@delegate:ResourceContentHash(1_634_917_664)
internal val Res.string.levelselect_stars_total: StringResource by lazy {
      StringResource("string:levelselect_stars_total", "levelselect_stars_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9917, 55),
      ))
    }

@delegate:ResourceContentHash(41_873_094)
internal val Res.string.levelselect_tier_progress: StringResource by lazy {
      StringResource("string:levelselect_tier_progress", "levelselect_tier_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9973, 57),
      ))
    }

@delegate:ResourceContentHash(1_466_483_662)
internal val Res.string.levelselect_title: StringResource by lazy {
      StringResource("string:levelselect_title", "levelselect_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10031, 33),
      ))
    }

@delegate:ResourceContentHash(-54_771_788)
internal val Res.string.mode_alphabets: StringResource by lazy {
      StringResource("string:mode_alphabets", "mode_alphabets", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10112, 34),
      ))
    }

@delegate:ResourceContentHash(-2_099_493_588)
internal val Res.string.mode_alphabets_sub: StringResource by lazy {
      StringResource("string:mode_alphabets_sub", "mode_alphabets_sub", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10065, 46),
      ))
    }

@delegate:ResourceContentHash(-1_836_411_928)
internal val Res.string.mode_brainstorm: StringResource by lazy {
      StringResource("string:mode_brainstorm", "mode_brainstorm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10271, 39),
      ))
    }

@delegate:ResourceContentHash(-1_425_879_847)
internal val Res.string.mode_brainstorm_sub: StringResource by lazy {
      StringResource("string:mode_brainstorm_sub", "mode_brainstorm_sub", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10147, 87),
      ))
    }

@delegate:ResourceContentHash(-1_268_324_672)
internal val Res.string.mode_brainstorm_tag: StringResource by lazy {
      StringResource("string:mode_brainstorm_tag", "mode_brainstorm_tag", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10235, 35),
      ))
    }

@delegate:ResourceContentHash(1_555_934_616)
internal val Res.string.mode_mathematics: StringResource by lazy {
      StringResource("string:mode_mathematics", "mode_mathematics", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10364, 40),
      ))
    }

@delegate:ResourceContentHash(-1_984_909_503)
internal val Res.string.mode_mathematics_sub: StringResource by lazy {
      StringResource("string:mode_mathematics_sub", "mode_mathematics_sub", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10311, 52),
      ))
    }

@delegate:ResourceContentHash(-528_689_416)
internal val Res.string.mode_riddles: StringResource by lazy {
      StringResource("string:mode_riddles", "mode_riddles", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10466, 36),
      ))
    }

@delegate:ResourceContentHash(-1_935_452_400)
internal val Res.string.mode_riddles_sub: StringResource by lazy {
      StringResource("string:mode_riddles_sub", "mode_riddles_sub", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10405, 60),
      ))
    }

@delegate:ResourceContentHash(2_053_777_348)
internal val Res.string.mode_solved_count: StringResource by lazy {
      StringResource("string:mode_solved_count", "mode_solved_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10503, 41),
      ))
    }

@delegate:ResourceContentHash(-1_045_627_322)
internal val Res.string.nav_home: StringResource by lazy {
      StringResource("string:nav_home", "nav_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10545, 24),
      ))
    }

@delegate:ResourceContentHash(2_128_440_428)
internal val Res.string.nav_settings: StringResource by lazy {
      StringResource("string:nav_settings", "nav_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10570, 32),
      ))
    }

@delegate:ResourceContentHash(-901_106_792)
internal val Res.string.notif_daily_challenge_body: StringResource by lazy {
      StringResource("string:notif_daily_challenge_body", "notif_daily_challenge_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10603, 86),
      ))
    }

@delegate:ResourceContentHash(995_491_345)
internal val Res.string.notif_daily_challenge_title: StringResource by lazy {
      StringResource("string:notif_daily_challenge_title", "notif_daily_challenge_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10690, 71),
      ))
    }

@delegate:ResourceContentHash(-579_713_125)
internal val Res.string.notif_reengagement_body: StringResource by lazy {
      StringResource("string:notif_reengagement_body", "notif_reengagement_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10762, 79),
      ))
    }

@delegate:ResourceContentHash(-1_081_658_520)
internal val Res.string.notif_reengagement_title: StringResource by lazy {
      StringResource("string:notif_reengagement_title", "notif_reengagement_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10842, 56),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("challenge_own_result", Res.string.challenge_own_result)
  map.put("challenge_play_more", Res.string.challenge_play_more)
  map.put("challenge_result_time", Res.string.challenge_result_time)
  map.put("challenge_result_won", Res.string.challenge_result_won)
  map.put("challenge_share", Res.string.challenge_share)
  map.put("challenge_start_fresh", Res.string.challenge_start_fresh)
  map.put("coach_levels_kicker", Res.string.coach_levels_kicker)
  map.put("coach_levels_next_body", Res.string.coach_levels_next_body)
  map.put("coach_levels_next_title", Res.string.coach_levels_next_title)
  map.put("coach_levels_resume_body", Res.string.coach_levels_resume_body)
  map.put("coach_levels_resume_title", Res.string.coach_levels_resume_title)
  map.put("coach_levels_tiers_body", Res.string.coach_levels_tiers_body)
  map.put("coach_levels_tiers_title", Res.string.coach_levels_tiers_title)
  map.put("coach_play_cell_body", Res.string.coach_play_cell_body)
  map.put("coach_play_cell_title", Res.string.coach_play_cell_title)
  map.put("coach_play_got_it", Res.string.coach_play_got_it)
  map.put("coach_play_hint_body", Res.string.coach_play_hint_body)
  map.put("coach_play_hint_title", Res.string.coach_play_hint_title)
  map.put("coach_play_kicker", Res.string.coach_play_kicker)
  map.put("coach_play_letters_body", Res.string.coach_play_letters_body)
  map.put("coach_play_letters_title", Res.string.coach_play_letters_title)
  map.put("coach_play_next", Res.string.coach_play_next)
  map.put("coach_play_skip", Res.string.coach_play_skip)
  map.put("coach_play_step", Res.string.coach_play_step)
  map.put("coach_resume_home_body", Res.string.coach_resume_home_body)
  map.put("coach_resume_home_title", Res.string.coach_resume_home_title)
  map.put("coach_resume_kicker", Res.string.coach_resume_kicker)
  map.put("coach_resume_play_body", Res.string.coach_resume_play_body)
  map.put("coach_resume_play_title", Res.string.coach_resume_play_title)
  map.put("common_back", Res.string.common_back)
  map.put("common_cancel", Res.string.common_cancel)
  map.put("common_done", Res.string.common_done)
  map.put("common_error_generic", Res.string.common_error_generic)
  map.put("common_loading", Res.string.common_loading)
  map.put("common_ok", Res.string.common_ok)
  map.put("common_retry", Res.string.common_retry)
  map.put("crossword_check", Res.string.crossword_check)
  map.put("crossword_clues", Res.string.crossword_clues)
  map.put("crossword_countdown_go", Res.string.crossword_countdown_go)
  map.put("crossword_daily_badge", Res.string.crossword_daily_badge)
  map.put("crossword_delete", Res.string.crossword_delete)
  map.put("crossword_direction_across", Res.string.crossword_direction_across)
  map.put("crossword_direction_down", Res.string.crossword_direction_down)
  map.put("crossword_filled", Res.string.crossword_filled)
  map.put("crossword_hints_left", Res.string.crossword_hints_left)
  map.put("crossword_hints_none", Res.string.crossword_hints_none)
  map.put("crossword_mistakes", Res.string.crossword_mistakes)
  map.put("crossword_next_clue", Res.string.crossword_next_clue)
  map.put("crossword_no_clue", Res.string.crossword_no_clue)
  map.put("crossword_no_stars", Res.string.crossword_no_stars)
  map.put("crossword_prev_clue", Res.string.crossword_prev_clue)
  map.put("crossword_progress", Res.string.crossword_progress)
  map.put("crossword_reveal_ad_caption", Res.string.crossword_reveal_ad_caption)
  map.put("crossword_reveal_ad_loading", Res.string.crossword_reveal_ad_loading)
  map.put("crossword_reveal_cell", Res.string.crossword_reveal_cell)
  map.put("crossword_reveal_cell_count", Res.string.crossword_reveal_cell_count)
  map.put("crossword_reveal_cell_count_short", Res.string.crossword_reveal_cell_count_short)
  map.put("crossword_reveal_cell_short", Res.string.crossword_reveal_cell_short)
  map.put("crossword_reveal_grid", Res.string.crossword_reveal_grid)
  map.put("crossword_reveal_grid_short", Res.string.crossword_reveal_grid_short)
  map.put("home_choose_mode", Res.string.home_choose_mode)
  map.put("home_daily", Res.string.home_daily)
  map.put("home_daily_done", Res.string.home_daily_done)
  map.put("home_daily_streak", Res.string.home_daily_streak)
  map.put("home_daily_subtitle", Res.string.home_daily_subtitle)
  map.put("home_play", Res.string.home_play)
  map.put("home_play_subtitle", Res.string.home_play_subtitle)
  map.put("home_progress_label", Res.string.home_progress_label)
  map.put("home_resume", Res.string.home_resume)
  map.put("home_resume_detail", Res.string.home_resume_detail)
  map.put("home_stat_solved", Res.string.home_stat_solved)
  map.put("home_stat_stars", Res.string.home_stat_stars)
  map.put("home_stat_streak", Res.string.home_stat_streak)
  map.put("home_subtitle", Res.string.home_subtitle)
  map.put("home_tagline", Res.string.home_tagline)
  map.put("home_title", Res.string.home_title)
  map.put("levelselect_empty", Res.string.levelselect_empty)
  map.put("levelselect_level_number", Res.string.levelselect_level_number)
  map.put("levelselect_locked", Res.string.levelselect_locked)
  map.put("levelselect_locked_tier", Res.string.levelselect_locked_tier)
  map.put("levelselect_resume", Res.string.levelselect_resume)
  map.put("levelselect_stars_total", Res.string.levelselect_stars_total)
  map.put("levelselect_tier_progress", Res.string.levelselect_tier_progress)
  map.put("levelselect_title", Res.string.levelselect_title)
  map.put("mode_alphabets", Res.string.mode_alphabets)
  map.put("mode_alphabets_sub", Res.string.mode_alphabets_sub)
  map.put("mode_brainstorm", Res.string.mode_brainstorm)
  map.put("mode_brainstorm_sub", Res.string.mode_brainstorm_sub)
  map.put("mode_brainstorm_tag", Res.string.mode_brainstorm_tag)
  map.put("mode_mathematics", Res.string.mode_mathematics)
  map.put("mode_mathematics_sub", Res.string.mode_mathematics_sub)
  map.put("mode_riddles", Res.string.mode_riddles)
  map.put("mode_riddles_sub", Res.string.mode_riddles_sub)
  map.put("mode_solved_count", Res.string.mode_solved_count)
  map.put("nav_home", Res.string.nav_home)
  map.put("nav_settings", Res.string.nav_settings)
  map.put("notif_daily_challenge_body", Res.string.notif_daily_challenge_body)
  map.put("notif_daily_challenge_title", Res.string.notif_daily_challenge_title)
  map.put("notif_reengagement_body", Res.string.notif_reengagement_body)
  map.put("notif_reengagement_title", Res.string.notif_reengagement_title)
}
